import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function KitchenTicket({ children }) {
  useInjectSaga({ key: 'settingsKitchenTicket', saga });
  useInjectReducer({ key: 'settingsKitchenTicket', reducer });

  return React.Children.only(children);
}

KitchenTicket.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withKitchenTicket } from './withKitchenTicket';
export default compose(withConnect, memo)(KitchenTicket);
